import React, { createContext, useReducer, useContext } from 'react';
import axios from "axios";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY} from "./constant";


const initialState = {
  loading: false,
  data: null,
  errorProduct: null,
  error: null,
  quantityUpdateIdfs: []
};


function productReducer(state, action){
  switch(action.type){
    case 'GET_PRODUCTS':
      return {
        ...state,
        loading : true,
      };
    case 'GET_PRODUCTS_SUCCESS':
      return {
        ...state,
        data: action.data,
        errorProduct : action.errorProduct,
        loading : false,
        quantityUpdateIdfs: Array.isArray(action.quantityUpdateIdfs) ? action.quantityUpdateIdfs : []
      };
    case 'GET_PRODUCTS_ERROR':
      return {
        ...state,
        error: action.error,
        loading : false,
      };
    case 'SET_PRODUCTS':
      return {
        ...state,
        data: action.data,
        loading : false,
      };
    case 'ADD_QUANTITY_UPDATING': {
      const current = Array.isArray(state.quantityUpdateIdfs) ? state.quantityUpdateIdfs : [];
      const idfs = action.id_fs;
      if (idfs == null) {
        return state;
      }
      if (current.includes(idfs)) {
        return state;
      }
      return {
        ...state,
        quantityUpdateIdfs: [...current, idfs],
      };
    }
    default:
      throw new Error(`Unhanded action type: ${action.type}`);
  }
}


const ProductStateContext = createContext(null);
const ProductDispatchContext = createContext(null);



export function ProductsProvider({ children }) {
  const [state, dispatch] = useReducer(productReducer, initialState);
  return (
    <ProductStateContext.Provider value={state}>
      <ProductDispatchContext.Provider value={dispatch}>
        {children}
      </ProductDispatchContext.Provider>
    </ProductStateContext.Provider>
  );
}

export function useProductsState() {
  const state = useContext(ProductStateContext);
  if (!state) {
    throw new Error('Cannot find UsersProvider');
  }
  return state;
}

// Dispatch 를 쉽게 사용 할 수 있게 해주는 커스텀 Hook
export function useProductsDispatch() {
  const dispatch = useContext(ProductDispatchContext);
  if (!dispatch) {
    throw new Error('Cannot find ProductsProvider');
  }
  return dispatch;
}


export async function getProducts(dispatch, centerId) {


  dispatch({ type: 'GET_PRODUCTS' });

  try {
    // 먼저 수량 업데이트 상태를 조회하여 현재 업데이트 중인 상품 idfs 목록을 확보한다.
    let quantityUpdateIdfs = []
    try {
      const base = `${process.env.REACT_APP_API_HOST}/product/quantity_update_status?token=${cookie.load(RECEIVER_COOKIE_KEY)}`
      const statusUrl = (centerId !== undefined && centerId !== null && centerId !== '') ? `${base}&center_id=${centerId}` : base
      const statusResp = await axios.get(statusUrl)
      if (statusResp.status === 200 && statusResp.data && statusResp.data.code === 200) {
        const results = statusResp.data.results
        if (results && Array.isArray(results) && results.length > 0) {
          // 응답 내 idfs(혹은 id 목록)를 배열로 수집
          // 서버 스펙: results가 [{idfs: number}, ...] 또는 { idfs: number[] } 형태일 수 있어 방어적으로 처리
          if (Array.isArray(results[0])) {
            quantityUpdateIdfs = results[0]
          } else if (Array.isArray(results.idfs)) {
            quantityUpdateIdfs = results.idfs
          } else {
            // results 배열의 각 항목에서 idfs 또는 id_fs를 추출
            quantityUpdateIdfs = results.map((r) => (r.idfs ?? r.id_fs)).filter((v) => v != null)
          }
        }
      }
    } catch (e) {
      // 상태 조회 실패 시 무시하고 빈 배열 유지
      quantityUpdateIdfs = []
    }

    const response = await axios.get(`${process.env.REACT_APP_API_HOST}/product?token=${cookie.load(RECEIVER_COOKIE_KEY)}`)
    // const response = await axios.get(`${process.env.REACT_APP_USER_API_HOST}/inventory/productInfoList?token=${cookie.load(RECEIVER_COOKIE_KEY)}`)
    if(response.status === 200 && response.data != null && response.data['code'] === 200){
            // setProducts(resp.data['results'])
            // setLoadingProducts(false)
      console.log('getProducts ', response.data)

      dispatch({ type: 'GET_PRODUCTS_SUCCESS', data: response.data['results'], errorProduct: response.data['error_product'], quantityUpdateIdfs });
    // }else if(response.status === 200 && response.data != null && response.data['code'] === 0){
      // history.replace('/signin')
      // dispatch({ type: 'GET_PRODUCTS_ERROR', error: '' });
    }else{
      dispatch({ type: 'GET_PRODUCTS_ERROR', error: 'cannot access to server', data: response.data });
    }

  } catch (e) {
    dispatch({ type: 'GET_PRODUCTS_ERROR', error: e });
  }
}

// 재고 수정 요청이 들어간 상품을 "수량 업데이트 중" 상태로 표시하기 위한 helper
export function addQuantityUpdating(dispatch, id_fs) {
  if (!dispatch) return;
  dispatch({ type: 'ADD_QUANTITY_UPDATING', id_fs });
}


export async function setNewProducts(dispatch, products) {

  dispatch({ type: 'SET_PRODUCTS', data:  products});

}

